import { isDefined } from "./isDefined";

export const isKeyOf = <objectType extends Record<string, unknown>>(
  object: objectType,
  key: null | number | string | symbol | undefined,
): key is keyof objectType => {
  return isDefined(key) && key in object;
};
